"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = exports.PaginationNumberedUnselected = exports.PaginationNumbered = exports.FieldsFocus = exports.FieldsError = exports.FieldsDefault = exports.ButtonTertiaryToggleGroupOff = exports.ButtonTertiaryToggleGroupOn = exports.ButtonSecondaryToggleGroupOff = exports.ButtonSecondaryToggleGroupOn = exports.ButtonPrimaryToggleGroupOff = exports.ButtonPrimaryToggleGroupOn = exports.ButtonTertiaryToggleOff = exports.ButtonTertiaryToggle = exports.ButtonSecondaryToggleOff = exports.ButtonSecondaryToggle = exports.ButtonPrimaryToggleOff = exports.ButtonPrimaryToggle = void 0;
// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonPrimaryToggle = 2;
exports.ButtonPrimaryToggle = ButtonPrimaryToggle;
var ButtonPrimaryToggleOff = 2;
exports.ButtonPrimaryToggleOff = ButtonPrimaryToggleOff;
var ButtonSecondaryToggle = 2;
exports.ButtonSecondaryToggle = ButtonSecondaryToggle;
var ButtonSecondaryToggleOff = 2;
exports.ButtonSecondaryToggleOff = ButtonSecondaryToggleOff;
var ButtonTertiaryToggle = 2;
exports.ButtonTertiaryToggle = ButtonTertiaryToggle;
var ButtonTertiaryToggleOff = 2;
exports.ButtonTertiaryToggleOff = ButtonTertiaryToggleOff;
var ButtonPrimaryToggleGroupOn = 1;
exports.ButtonPrimaryToggleGroupOn = ButtonPrimaryToggleGroupOn;
var ButtonPrimaryToggleGroupOff = 1;
exports.ButtonPrimaryToggleGroupOff = ButtonPrimaryToggleGroupOff;
var ButtonSecondaryToggleGroupOn = 1;
exports.ButtonSecondaryToggleGroupOn = ButtonSecondaryToggleGroupOn;
var ButtonSecondaryToggleGroupOff = 1;
exports.ButtonSecondaryToggleGroupOff = ButtonSecondaryToggleGroupOff;
var ButtonTertiaryToggleGroupOn = 1;
exports.ButtonTertiaryToggleGroupOn = ButtonTertiaryToggleGroupOn;
var ButtonTertiaryToggleGroupOff = 1;
exports.ButtonTertiaryToggleGroupOff = ButtonTertiaryToggleGroupOff;
var FieldsDefault = 1;
exports.FieldsDefault = FieldsDefault;
var FieldsError = 2;
exports.FieldsError = FieldsError;
var FieldsFocus = 2;
exports.FieldsFocus = FieldsFocus;
var PaginationNumbered = 1;
exports.PaginationNumbered = PaginationNumbered;
var PaginationNumberedUnselected = 1;
exports.PaginationNumberedUnselected = PaginationNumberedUnselected;
var Toggle = 2;
exports.Toggle = Toggle;